import {
    CONFIRMED_CREATE_ROLE_ACTION,
    CONFIRMED_DELETE_ROLE_ACTION,
    CONFIRMED_EDIT_ROLE_ACTION,
    CONFIRMED_GET_ROLES,
    CREATE_ROLE_ACTION,    
    ROLE_ERROR_ACTION,
    CLEAR_ROLE_ERROR,
    LOADING_ROLES,
    LOADING_TOGGLE_ACTION,
    CONFIRMED_GET_ROLE_PERMISSIONS
} from '../actions/RoleTypes';

const initialState = {
    roles: [],
    loading: false,
    createRoleError: {},
    permissions:[]
};

export default function RoleReducer(state = initialState, actions) {
    if (actions.type === CREATE_ROLE_ACTION) { 
        return {
            ...state,
            roles: [...state.roles],
        };
    }

    if (actions.type === CONFIRMED_DELETE_ROLE_ACTION) {
        const roles = state.roles.filter(role => role.id !== actions.payload);
        return {
            ...state,
            roles,
        };
    }

    if (actions.type === CONFIRMED_EDIT_ROLE_ACTION) {
        const roles = state.roles.map(role => 
            role.id === actions.payload.id ? actions.payload : role
        );
        return {
            ...state,
            roles,
        };
    }

    if (actions.type === CONFIRMED_CREATE_ROLE_ACTION) {
        return {
            ...state,
            roles: [...state.roles, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_ROLE_PERMISSIONS) {
        return {
            ...state,
            permissions: actions.payload,
        };
    }

    if (actions.type === CONFIRMED_GET_ROLES) {
        return {
            ...state,
            roles: actions.payload,
        };
    }

    if (actions.type === LOADING_ROLES) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === ROLE_ERROR_ACTION) {
        return {
            ...state,
            createRoleError: actions.payload,
        };
    }

    if (actions.type === CLEAR_ROLE_ERROR) {
        return {
            ...state,
            createRoleError: {},
        };
    }
    if (actions.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            loading: actions.payload,
        };
    }
    return state;
}
